// Share only concurrent reads. Completed stock is never cached across refreshes.
const pendingReads = new Map();

const sessionKey = () => {
  try { return `${sessionStorage.getItem('isLoggedIn') || ''}:${localStorage.getItem('user') || ''}`; }
  catch { return ''; }
};

export const clearInventoryReads = () => pendingReads.clear();

export function readInventoryRows(apiBaseUrl, { force = false } = {}) {
  const key = `${apiBaseUrl}|${sessionKey()}`;
  if (!force && pendingReads.has(key)) return pendingReads.get(key);
  const request = (async () => {
    const response = await fetch(`${apiBaseUrl}api/InventoryData/light`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Failed to fetch inventory: ${response.status}`);
    const rows = await response.json();
    return Array.isArray(rows) ? rows : [];
  })();
  pendingReads.set(key, request);
  const release = () => { if (pendingReads.get(key) === request) pendingReads.delete(key); };
  request.then(release, release);
  return request;
}

export function inventoryImageUrl(row, apiBaseUrl) {
  if (row.imageData) return `data:${row.imageContentType || 'image/png'};base64,${row.imageData}`;
  if (!row.hasImage) return '';
  return `${apiBaseUrl}api/InventoryData/${encodeURIComponent(row.id)}/image?v=${encodeURIComponent(row.imageVersion || row.lastUpdated || '')}`;
}
